(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.faq--with-toc').forEach(function(section) {
      var links = section.querySelectorAll('.faq__toc-link');
      var categories = section.querySelectorAll('.faq__category');
      if (!links.length || !categories.length) return;

      var clickScrolling = false;
      var clickTimer;

      var observer = new IntersectionObserver(function(entries) {
        if (clickScrolling) return;
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var id = entry.target.id;
            links.forEach(function(link) {
              link.classList.toggle('is-active', link.getAttribute('href') === '#' + id);
            });
          }
        });
      }, { rootMargin: '-15% 0px -70% 0px', threshold: 0 });

      categories.forEach(function(cat) { observer.observe(cat); });

      links.forEach(function(link) {
        link.addEventListener('click', function(e) {
          e.preventDefault();
          var target = document.querySelector(link.getAttribute('href'));
          if (!target) return;

          clickScrolling = true;
          clearTimeout(clickTimer);
          links.forEach(function(l) { l.classList.toggle('is-active', l === link); });

          target.scrollIntoView({ behavior: 'smooth', block: 'start' });

          clickTimer = setTimeout(function() { clickScrolling = false; }, 1000);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
